import BstlArtikel from "./bstl_artikel"
import Buchung from "./buchung"
import Identity from "./identity"
import ReservierungVorbestellungPending from "./reservierung_vorbestellung_pending"

export default class ReservierungNeu extends Buchung {
  filialeId: string
  tischId: string
  filialeBezeichnung: string
  tischBezeichnung: string
  zeitVon: string
  zeitBis: string
  kundeNachname: string
  kundeVorname: string
  kundeTelefon: string
  kundeEmail: string
  erstellungsZp: string
  online: boolean = true
  personen: number = 2
  vorbestellung: BstlArtikel[]
  vorbestellungPending: ReservierungVorbestellungPending
  storniert: boolean = false
  abgeschlossen: boolean = false
  vorbestellungMoeglich: boolean = true
}
